import React, {Component, Fragment} from 'react';
import {connect} from 'react-redux';
import {Button} from 'reactstrap';
import autobind from 'autobind-decorator';
import Dialog from '../../apa/containers/Dialog';

@connect(
    state => (
        {
            auth: state.apa
        }
    )
)
export default class DeleteCustomerManual extends Component {

    constructor(props) {
        super(props);
        this.state = {
            isOpen: false,
        }
    }

    @autobind
    toggle() {
        this.setState(
            {
                isOpen: !this.state.isOpen
            }
        )
    }

    render() {
        const customerManual = this.props.customer_manual;
        return (
            <Fragment>
                <Button color='danger' onClick={this.toggle}>
                    <i className='fa fa-trash'> </i>
                </Button>
                <Dialog
                    isOpen={this.state.isOpen}
                    toggle={this.toggle}
                    confirm={() => this.deleteCustomerManual(customerManual.id)}
                    title={'Betriebsanweisung löschen'}
                >
                    Sind Sie sicher?
                </Dialog>
            </Fragment>
        )
    }

    @autobind
    deleteCustomerManual(id) {
        const headers = {
            'Content-Type': 'application/json',
            'Authorization': `Token ${this.props.auth.token}`
        };
        fetch(
            `/api/customer_templates/${id}/`,
            {headers, method: 'DELETE'}
        ).then(
            () => {
                this.toggle();
                this.props.callback();
            }
        )

    }
}
